var _mask, _g, _path, _path2, _path3, _path4, _path5, _mask2, _g2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTestRunLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 24
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.000200272H19.1055V24H0V0.000200272Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3525 0.000200272H1.7525C0.784496 0.000200272 -0.00050354 0.8102 -0.00050354 1.8092V22.1902C-0.00050354 23.1892 0.784496 24.0002 1.7525 24.0002H12.9745C11.0095 22.5852 9.7205 20.2372 9.7205 17.5762C9.7205 17.0342 9.7745 16.5052 9.8755 15.9932H6.6325C6.3405 15.9932 6.1315 15.7892 6.1315 15.5032V14.5212C6.1315 14.2762 6.3405 14.0312 6.6325 14.0312H10.5485C11.0695 12.9742 11.8165 12.0582 12.7235 11.3462H6.6325C6.3405 11.3462 6.1315 11.1422 6.1315 10.8552V9.8742C6.1315 9.6292 6.3405 9.3842 6.6325 9.3842H14.9765C15.2265 9.3842 15.4765 9.6292 15.4765 9.8742V9.9832C16.0645 9.8332 16.6745 9.7452 17.3065 9.7452C17.9275 9.7452 18.5285 9.8302 19.1055 9.9752V1.8092C19.1055 0.8102 18.3215 0.000200272 17.3525 0.000200272Z",
    fill: "#3B7FF5"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9766 9.384H6.6326C6.3406 9.384 6.1316 9.629 6.1316 9.874V10.856C6.1316 11.142 6.3406 11.346 6.6326 11.346H12.7236C13.5316 10.712 14.4626 10.243 15.4766 9.984V9.874C15.4766 9.629 15.2266 9.384 14.9766 9.384Z",
    fill: "#B4CEFA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.1318 14.5217V15.5027C6.1318 15.7897 6.3408 15.9937 6.6328 15.9937H9.8758C10.0138 15.2997 10.2458 14.6447 10.5488 14.0317H6.6328C6.3408 14.0317 6.1318 14.2767 6.1318 14.5217Z",
    fill: "#B4CEFA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5586 4.7365C17.8816 4.7365 18.2056 4.9815 18.2056 5.2265V6.2085C18.2056 6.4945 17.8816 6.6985 17.5586 6.6985H6.7786C6.4016 6.6985 6.1316 6.4945 6.1316 6.2085V5.2265C6.1316 4.9815 6.4016 4.7365 6.7786 4.7365H17.5586Z",
    fill: "#B4CEFA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.4619 4.5724C4.0789 4.5724 4.6299 5.1134 4.6299 5.7174C4.6299 6.3534 4.0789 6.8624 3.4619 6.8624C2.8129 6.8624 2.2939 6.3534 2.2939 5.7174C2.2939 5.1134 2.8129 4.5724 3.4619 4.5724Z",
    fill: "#B4CEFA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.4619 9.2199C4.0789 9.2199 4.6299 9.7609 4.6299 10.3649C4.6299 11.0009 4.0789 11.5099 3.4619 11.5099C2.8129 11.5099 2.2939 11.0009 2.2939 10.3649C2.2939 9.7609 2.8129 9.2199 3.4619 9.2199Z",
    fill: "#B4CEFA"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 11,
    width: 13,
    height: 13
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6187 11.4403H23.9997V24H11.6187V11.4403Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6797 18.3273L16.2867 20.8853C15.8877 21.1133 15.4127 20.8353 15.4127 20.3533V15.0863C15.4127 14.6313 15.8877 14.3513 16.2867 14.5553L20.6797 17.2643C21.1047 17.5173 21.1047 18.0993 20.6797 18.3273ZM17.8097 11.4403C14.3897 11.4403 11.6187 14.2513 11.6187 17.7203C11.6187 21.1893 14.3897 24.0003 17.8097 24.0003C21.2297 24.0003 23.9997 21.1893 23.9997 17.7203C23.9997 14.2513 21.2297 11.4403 17.8097 11.4403Z",
    fill: "#4C94FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestRunLight);
export default __webpack_public_path__ + "static/media/test-run-light.fc5a374bdff6e64d69576ce26fcd0b7e.svg";
export { ForwardRef as ReactComponent };